import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import SelectSearch from 'react-select-search';
import { IC_CLOSE_GREY } from '../../../Assets/images';
import InputFieldControl from '../InputField/InputField';
import SearchDropDownStyled from './SearchDropDownStyled';

const SearchDropDown = (props) => {
  const wrapperRef = useRef(null);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDropDown(false);
        setSearch('');
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <SearchDropDownStyled>
      <div ref={wrapperRef} className="customSearchDropdown">
        <InputFieldControl
          isLabel
          label="Nationality"
          textType="text"
          placeholder={props?.placeholder}
          data-test="nationality"
          name="nationality"
          valueType={props?.valueType}
          customClass="dropdownInput"
          isInvalid={!!props?.isInvalid}
          errorMessage={props?.errorMessage}
          onClick={() => setOpenDropDown(true)}
          disabled={props?.showFailureModal || props?.isExistingUser}
        />
        {openDropDown && (
          <SelectSearch
            options={props?.options || []}
            value={props?.valueType}
            name="Nationality"
            closeOnSelect
            onChange={(value) => {
              props?.onChange(value);
              setOpenDropDown(false);
            }}
            getOptions={(query) =>
              props?.options?.filter((str) => str?.name?.toUpperCase()?.indexOf(query?.toUpperCase()) === 0)
            }
            emptyMessage="No Result Found"
            autoFocus
            className="select-search-demo"
            onBlur={() => {
              setSearch('');
            }}
            renderValue={(valueProps) => (
              <div
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <input
                  {...valueProps}
                  className="select-search-input"
                  placeholder="Search"
                  value={search}
                  onChange={({ target }) => {
                    valueProps.onChange({ target });
                    setSearch(target.value);
                  }}
                />
                {search && (
                  <div
                    onClick={(e) => {
                      setSearch('');
                      e.stopPropagation();
                    }}
                    className="closeButton"
                  >
                    <Image src={IC_CLOSE_GREY} alt="close" />
                  </div>
                )}
              </div>
            )}
            search
          />
        )}
      </div>
    </SearchDropDownStyled>
  );
};

SearchDropDown.propTypes = {
  valueType: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.string,
  onChange: PropTypes.func,
  isInvalid: PropTypes.string,
  errorMessage: PropTypes.string,
};

SearchDropDown.defaultProps = {};

export default SearchDropDown;
